"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'parentalPin';
exports.FETCH_USER_PARENTAL_SETTINGS = exports.namespace + "/FETCH_USER_PARENTAL_SETTINGS";
exports.SET_PARENTAL_CONTROLS = exports.namespace + "/SET_PARENTAL_CONTROLS";
exports.SET_PARENTAL_PIN = exports.namespace + "/SET_PARENTAL_PIN";
exports.SET_PARENTALLY_APPROVED_CLASSIFICATION = exports.namespace + "/SET_PARENTALLY_APPROVED_CLASSIFICATION";
exports.SET_PIN_VALIDATION_STATUS = exports.namespace + "/SET_PIN_VALIDATION_STATUS";
exports.ENTER_PARENTAL_PIN = exports.namespace + "/ENTER_PARENTAL_PIN";
exports.VALIDATE_PARENTAL_PIN = exports.namespace + "/VALIDATE_PARENTAL_PIN";
exports.CLEAR_VALIDATE_PARENTAL_PIN = exports.namespace + "/CLEAR_VALIDATE_PARENTAL_PIN";
exports.RESET_PARENTAL_PIN = exports.namespace + "/RESET_PARENTAL_PIN";
//# sourceMappingURL=constants.js.map